<template>
  <v-row class="align-center d-flex h-100">
    <v-snackbar
        id="alertSnackbar"
      top
      v-model="snackbar.visible"
      :color="snackbar.color"
      class="snackbar-shadow">
      <div class="d-flex align-start alert-notify">
        <v-icon
            id="iconNotifications"
          size="24"
          class="text-white me-3 mt-1 material-icons-round"
          >notifications
        </v-icon>
        <p class="mb-0">
          <span class="font-size-root font-weight-600">Error</span>
          <br />
          {{ snackbar.text }}
        </p>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          id="btnCloseSnackbar"
          icon
          elevation="0"
          max-width="136"
          :ripple="false"
          height="43"
          class="font-weight-600 text-capitalize py-3 px-6 rounded-sm"
          color="rgba(255,255,255, .85)"
          @click="snackbar.visible = false"
          v-bind="attrs">
          <v-icon size="13">fas fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-col
      lg="4"
      md="7"
      class="mx-auto">
      <v-card class="card-shadow border-radius-xl py-1">
        <div class="card-padding text-center mt-n7 bg-gradient-primary border-radius-lg mx-4">
          <h4 class="text-h4 text-white font-weight-bold" id="headerTitle">Login</h4>
        </div>
        <div class="card-padding">
          <v-text-field
            id="acName"
            v-model="name"
            label="Name"
            placeholder="Name"
            color="#blueTitle"
            required
            class="font-size-input input-style"
            v-on:keydown.enter="login"></v-text-field>

          <v-text-field
            id="acPassword"
            v-model="password"
            label="Password"
            placeholder="Password"
            color="#3F87EF"
            required
            type="password"
            class="font-size-input input-style"
            v-on:keydown.enter="login"></v-text-field>

          <v-checkbox
            id="rememberMeCheckBox"
            v-model="checkbox"
            color="#141727"
            :ripple="false"
            class="ma-0 checkbox-custom checkbox-thinner"
            hide-details>
            <template v-slot:label>
              <span class="text-body text-sm ls-0">Remember me </span>
            </template>
          </v-checkbox>

          <v-btn
            id="btnLogin"
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100"
            color="#5e72e4"
            small
            @click="login"
            >Login
          </v-btn>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { apiPost } from '@/api'
import { api } from '@/assets/boot/axios'

export default {
  name: 'Login',
  data() {
    return {
      checkbox: false,
      name: '',
      password: '',
      snackbar: {
        color: null,
        visible: false,
      },

      url: process.env.VUE_APP_API_URL,
      title: process.env.VUE_APP_TITLE,
    }
  },
  created() {
    localStorage.clear()
    window.addEventListener('keypress', this.doCommand)
  },
  methods: {
    doCommand(e) {
      if (e.key === 'Enter') {
        this.login()
      }
    },
    async login() {
      await apiPost('/auth/login/', {
        username: this.name,
        password: this.password,
      })
        .then((r) => {
          localStorage.setItem('AUTH_TOKEN', r.data.accessToken)
          api.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.accessToken

          localStorage.setItem('userIdent', r.data.smallUser.ident)
          localStorage.setItem('userName', r.data.smallUser.userName)
          localStorage.setItem('userRoles', JSON.stringify(r.data.smallUser.roles) ? JSON.stringify(r.data.smallUser.roles) : [])

          this.SnackbarShow('Success', 'Alles fine')
          this.$router.push('/')
        })
        .catch((e) => {
          this.SnackbarShow('Warning', e)
        })
    },
    SnackbarShow(type, text) {
      if (!type) return
      switch (type) {
        case 'Default':
          this.snackbar = {
            color: '#172b4d',
            visible: true,
          }
          break
        case 'Info':
          this.snackbar = {
            color: '#11cdef',
            visible: true,
          }
          break
        case 'Success':
          this.snackbar = {
            color: '#2dce89',
            visible: true,
            text: text,
          }
          break
        case 'Warning':
          this.snackbar = {
            color: '#fb6340',
            visible: true,
            text: text,
          }
          break
        case 'Danger':
          this.snackbar = {
            color: '#f5365c',
            visible: true,
          }
          break
      }
    },
  },
  watch: {},
}
</script>
